module.exports = __webpack_public_path__ + "img/siteEmpty.ccce6f3e.png";